import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import styles from "../styles/AboutHome.module.css"; // only for image animation

/* Simple, reliable fade-up: each block fades in and rises, gently staggered. */
const EASE = [0.22, 1, 0.36, 1];

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 32 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 1, ease: EASE, delay },
});

const AboutHome = () => {
  return (
    <section className="section-8i">
      <div className="container-8i">
        <div className="row align-items-center">
          {/* Left Image */}
          <div
            className={`col-md-5 col-12 d-flex justify-content-center ${styles.ahImageWrap}`}
            data-aos="fade-up"
          >
            <img
              src="/about_us.png"
              alt="About 8 Insights"
              className={`hide-in-mobile ${styles.ahMovingImage}`}
            />
          </div>

          {/* Right Content */}
          <div className="col-md-7 col-12">
            <motion.span className={styles.ahKicker} {...fadeUp(0)} />

            <motion.h2 className="section-title" {...fadeUp(0.1)}>
              <span>Welcome To </span>
              <span style={{ whiteSpace: "nowrap", color: "#091362" }}>
                8&nbsp;Insights
              </span>
            </motion.h2>

            <motion.h3 className="section-sub-heading" {...fadeUp(0.25)}>
              Strategic Advisory &amp; Custom-Built Digital Solutions
            </motion.h3>

            <motion.div className="content" {...fadeUp(0.4)}>
              <p>
                At 8 Insights, we combine deep industry expertise with practical
                execution. We work alongside our clients to shape clear
                strategies, create meaningful digital experiences, and drive
                outcomes that make a real difference to their business.
              </p>
            </motion.div>

            <motion.div {...fadeUp(0.55)}>
              <Link to="/about" className={`btn-primary-8i ${styles.ahCta}`}>
                Learn More{" "}
                <span className={styles.ahArrow} aria-hidden="true">→</span>
              </Link>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHome;
